export default "__VITE_ASSET__b8e5703f__"